export default function flexCenterColumn() {
  return /*css*/`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `;
}